export default __webpack_public_path__ + "static/media/odin-node-gold.233dfa72.svg";